exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".content[data-v-5467ee66]{width:100%;border:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;overflow:hidden}.content-h[data-footer=show][data-v-5467ee66]{height:calc(100% - 91px)}.content-h[data-footer=hide][data-v-5467ee66]{height:calc(100% - 60px)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-5467ee66","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Content.vue
// module id = 181
// module chunks = 0 1